import { render } from "./MainTitleCard.vue?vue&type=template&id=58836ec9&scoped=true"
import script from "./MainTitleCard.vue?vue&type=script&lang=js"
export * from "./MainTitleCard.vue?vue&type=script&lang=js"

import "./MainTitleCard.vue?vue&type=style&index=0&id=58836ec9&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58836ec9"]])

export default __exports__